import { useEffect, useState } from "react";

import { toAbsoluteUrl } from "../../helpers";
import { useAuth } from "../../modules/auth";
import { useLazyReadMultipleQuery } from "../services/data/tableDataApi";

export const ProfilePicture = () => {
  const { user, siteId } = useAuth();
  const [getContact, { data: contacts }] = useLazyReadMultipleQuery()
  const [base64, setBase64] = useState<string>();

  const entityId: string = "b6a15cff-117d-4185-8134-815ae10075af";

  useEffect(() => {
    if (!user || !user.contactId || !siteId)
      return;

    getContact({
      userId: user.userId,
      portalId: siteId,
      tableId: entityId,
      fieldList: [],
    });

    // eslint-disable-next-line
  }, [user])

  useEffect(() => {
    if (!contacts || contacts.count !== 1)
      return;

    const contact = contacts.records[0]
    const { entityimage } = contact as { entityimage: string }
    if (entityimage)
      setBase64(contact["entityimage"])
  }, [contacts])

  return <>
    {(!!base64) ? <>
      <img alt='Logo' src={`data:image/png;base64, ${base64}`} />
    </> : <>
      <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.png')} />
    </>}
  </>
}
